import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { AbilityType } from "../../entities/ability-types";

@Injectable()
export class AbilityTypeRepo extends Repository<AbilityType>{
    constructor(private dataSource: DataSource) {
        super(AbilityType, dataSource.createEntityManager());
    }
}
